/**
* Components are lazy-loaded - See "Grouping Components in the Same Chunk"
* http://router.vuejs.org/en/advanced/lazy-loading.html
*/
/* eslint-disable global-require */

export const Signin = r => require.ensure([], () => r(require('../components/forms/signin')), 'auth-bundle')

export const Signup = r => require.ensure([], () => r(require('../components/forms/signup')), 'auth-bundle')

export const GoogleAuthorizing = r => require.ensure([], () => r(require('../components/forms/authorizing')), 'auth-bundle')

export const InstallApp = r => require.ensure([], () => r(require('../components/forms/installApp')), 'auth-bundle')

export const NotAllowed = r => require.ensure([], () => r(require('../components/forms/userNotAllowed')), 'auth-bundle')

export const ApiAccess  = r => require.ensure([], () => r(require('../components/forms/apiNotAccess')), 'auth-bundle')

export const terms  = r => require.ensure([], () => r(require('../components/forms/terms')), 'auth-bundle')

export const userExtension  = r => require.ensure([], () => r(require('../components/forms/userExtension')), 'auth-bundle')

export const RequestInitiate  = r => require.ensure([], () => r(require('../components/forms/requestInitiate')), 'auth-bundle')

export const PasswordReset  = r => require.ensure([], () => r(require('../components/forms/change_password')), 'auth-bundle')

export const domain_authorized  = r => require.ensure([], () => r(require('../components/forms/domain_authorized')), 'auth-bundle')

export const verfication  = r => require.ensure([], () => r(require('../components/forms/verfication')), 'auth-bundle')

export const userchangepassword = r =>require.ensure([],()=>r(require('../components/forms/userchangepassword')),'auth-bundle')

export const esaReporting = r => require.ensure([], () => r(require('../components/forms/esaReporting')), 'auth-bundle')

export const support = r => require.ensure([], () => r(require('../components/forms/contactus/support')), 'auth-bundle')



// WEBPACK FOOTER //
// ./src/app/auth/routes/components.js